import { Link } from "react-router-dom";

export default function KpiCard({ icon, title, value, loading, to }) {
  return (
    <Link to={to} className="kpi-card flex-fill d-flex align-items-center kpi-card-link">
      <div className="icon-circle">
        {icon}
      </div>
      <div className="ms-3">
        <p className="kpi-title mb-1">{title}</p>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <h3 className="kpi-value mb-0">{value}</h3>
        )}
      </div>
    </Link>
  );
}
